import { Router } from "@/router";

export function App() {
  return <Router />;
}
